import { ShipmentItemDto, ShipmentItemModel } from '../types/shipment-items'

export const transformShipmentItemDto = ({
  name,
  image_url,
}: ShipmentItemDto): ShipmentItemModel => {
  return {
    name,
    imageUrl: image_url,
  }
}

export const transformShipmentItemsResponse = (response: {
  items: Array<ShipmentItemDto>
}): Array<ShipmentItemModel> => response.items.map(transformShipmentItemDto)
